import { FC } from 'react';

import { Theme, styled } from '../theme';
import SvgIcon from './SvgIcon';

export const SELECTED_CHECK_ICON_WIDTH = 14;
const SELECTED_CHECK_ICON_HEIGHT = 11;

const Icon = styled(SvgIcon)({
    flexShrink: 0,
});

const getIconColor = (theme: Theme) => theme.color.green1;

interface Props {
    alt?: string;
    className?: string;
}

const SelectedCheckIcon: FC<Props> = ({ alt = 'Selected', className }) => (
    <Icon
        src="/icons/ic-selected.svg"
        alt={alt}
        width={SELECTED_CHECK_ICON_WIDTH}
        height={SELECTED_CHECK_ICON_HEIGHT}
        color={getIconColor}
        className={className}
    />
);

export default SelectedCheckIcon;
